import Spinners from "./Spinner";
import "./custom-components.style.scss";

// Plain spinner for now. The branded animation below (butterfly in a spinning
// gradient ring, wordmark, progress bar) is kept in case we bring it back —
// its styles still live in custom-components.style.scss under .exora-loader-*,
// and the boot splash in public/index.html is a standalone copy of the same
// design.
//
// import { celcomDigiIcon, celcomDigiWordmark } from "../../assets/images";
//
// const MainLoader = () => (
//   <div className="loader_overlay">
//     <div className="page_loader">
//       <div className="exora-loader">
//         <div className="exora-loader-badge">
//           <span className="exora-loader-ripple" />
//           <span className="exora-loader-ripple" />
//           <span className="exora-loader-ripple" />
//           <span className="exora-loader-ring" />
//           <span className="exora-loader-orbit" />
//           <img
//             src={celcomDigiIcon}
//             alt="CelcomDigi"
//             className="exora-loader-logo"
//           />
//         </div>
//         <div className="exora-loader-brand">
//           <img
//             src={celcomDigiWordmark}
//             alt="CelcomDigi"
//             className="exora-loader-brand-mark"
//           />
//         </div>
//         <div className="exora-loader-sub">Loading your workspace</div>
//         <div className="exora-loader-bar" />
//       </div>
//     </div>
//   </div>
// );

const MainLoader = () => (
  <div className="loader_overlay">
    <div className="page_loader">
      <Spinners className="main-loader-spinner" />
    </div>
  </div>
);

export default MainLoader;
